import { useEffect, useState } from 'react'
import { BI_MENU } from '../../../../infrastructure/constants/api'
import useMutation from '../../../../infrastructure/hooks/useMutation'

export const usePorwerBI = (id) => {
  const [getMenuBi] = useMutation(BI_MENU + id)
  const [BI, setBI] = useState(null)
  const [loading, setLoading] = useState(false)
  /**
   * get token and data from microsoft
   *
   *
   * @author   ehernandez
   * @param   {Object} item
   */

  const getToken = async () => {
    setLoading(true)
    const { success, data } = await getMenuBi({ method: 'get' })
    setLoading(false)
    if (success) {
      setBI(data)
    }

    return null
  }

  useEffect(() => {
    getToken()
  }, [])

  return { getToken, BI, loading }
}
